import React from "react";
import { S2DLayout } from "../../S2DLayout";
import styles from "./OtherFlow.scss";

export class OtherFlow extends React.PureComponent {
  render() {
    const { subtitle, onPrev, routeId, step } = this.props;
    return (
      <S2DLayout
        title="Supported Devices"
        subtitle={subtitle}
        onClickPrev={onPrev}
        onClickNext={() => {
          window.location.href = `/routes/${routeId}`;
        }}
        nextText={"Return to Route"}
        step={step}
        stepCount={2}
      >
        <div className={styles.OtherFlow}>
          <div className={styles.instructions}>
            <p>Ride with GPS routes can be used with a wide range of GPS units.</p>
            <p>
              Please see our{" "}
              <a href="https://ridewithgps.com/help/compatible-devices" target="_blank">
                help page
              </a>{" "}
              for a list of compatible devices.
            </p>
          </div>
        </div>
      </S2DLayout>
    );
  }
}
